import { BASE_URL } from 'config/urls';

import { callUrl, get } from 'utils/sdk';

export const fetchStudentsList = ({ search }) =>
  callUrl(
    get,
    `${BASE_URL}/v1/trackers/student-portfolio/students-list/?search=${search}`
  );
